@if(accSessionDetails(); as details) {
<div class="acc-session-details-part bg-light rounded shadow-sm p-3 h-100">
	<div class="d-flex mb-2">
		<div class="fw-bold me-2">All times are shown in:</div>
		<div>{{details.timezone}}</div>
	</div>

	<div class="d-flex">
		<div class="fw-bold me-2">Topic:</div>
		<div>{{details.topicName}}</div>
	</div>

	<div class="d-flex">
		<div class="fw-bold me-2">Trimester:</div>
		<div>{{details.trimesterName}}</div>
	</div>

	<div class="d-flex">
		<div class="fw-bold me-2">Language:</div>
		<div>{{details.language}}</div>
	</div>

	<div class="d-flex">
		<div class="fw-bold me-2">Surveys:</div>
		<div>{{details.countOfSurveys}}</div>
	</div>

	<div class="d-flex">
		<div class="fw-bold me-2">Program Facilitator:</div>
		@if(details.facilitator && details.facilitator.personId){
		<span role="button" type="button" class="text-decoration-underline" (click)="openPersonDialog(details.facilitator.personId)">
			{{details.facilitator.fullName}}
		</span>
		}@else {

		<span>{{details.facilitator?.fullName ?? 'N/A'}}</span>
		}
	</div>

	<div class="d-flex mt-4">
		<div class="fw-bold me-2">Event Start:</div>
		<div>{{details.eventStartDate }}</div>
	</div>

	<div class="d-flex">
		<div class="fw-bold me-2">Event End:</div>
		<div>{{details.eventEndDate}}</div>
	</div>

	<div class="d-flex mt-4">
		<div class="fw-bold me-2">Specialists available:</div>
		<div>{{details.specialists.length}}</div>
	</div>

	<div class="d-flex">
		<div class="fw-bold">Assigned Specialists:</div>

		@if(details.assignedSpecialists.length){
		<ul>
			@for(specialist of details.assignedSpecialists;track $index;){
			<li>
				<span role="button" type="button" class="text-decoration-underline"
					(click)="openPersonDialog(specialist.personId)">
					{{specialist.fullName}}
				</span>
			</li>
			}
		</ul>
		}@else{
		<div>&nbsp;None</div>
		}
	</div>
</div>
}